import { Component, OnInit } from '@angular/core';
import jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor() {}

  hasRunsPermission: boolean = false;

  ngOnInit(): void {
    const { allowedPermissions } = this.getDecodedAccessToken();
    this.hasRunsPermission = !!(allowedPermissions || []).find(
      (item) => item.name.toLowerCase() === 'corrida'
    );
  }

  private getDecodedAccessToken(): any {
    try {
      return jwt_decode(localStorage.getItem('token').substring(7));
    } catch (Error) {
      return null;
    }
  }
}
